<template>
		<div class="info-component-container">
				<button class="infoBtn" @click="onClick"><img :src="info_data.info_icon" alt="Open Info"/></button>
			</div>
</template>

<script>
import { mapState } from 'vuex';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'InfoButton',
	mixins: [msEdgeImageSwap],
	computed: {
		...mapState({ // get data from wordpress info config page
			info_data: state => state.config.data.info,
		}),
	},
	methods: {
		onClick() {
			this.$store.commit('toggleInfoOpen', true);
		},
	},
	mounted() {
		this.swapEdgeImages();
	},
};
</script>

<style lang="scss" scoped>
	.info-component-container{
		width: 100%;
		height: 4%;
		min-height: 25px;
		position: absolute;
		top: 100%;
		transform: translateY(-150%);
		left: 0;
		z-index: 1000000;
		@include breakpoint(xs){
			transform: translateY(-120%);
		}
	}
	.infoBtn{
		display: inline-block;
		position: absolute;
		width: 2.25%;
		min-width: 20px;
		transform: translateX(50%);
		height: 100%;
		padding: 0;
		left: 0;
		top: 0;
		cursor: pointer;
		background: none;
		border: none;
		outline: none;
		img{
			width: 100%;
			height: auto;
			cursor: pointer;
			transform: scale(1);
		}
		&:hover{
			cursor: pointer;
			img{
				transform: scale(1.1);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/InfoButton.vue